<template>
  <div ref="card" class="card" @click="$emit('flipEvent')">
    <div class="card-item card-frontend" :class="[type === 1 ? 'light' : '', status === 1 ? 'no-anime' : '']">
      <div class="card-inner" v-if="status === 1 || $bus.shuffleAnime">
        <div class="card-info">
          <img ref="cardImg" class="card-img" :class="status === 1 || !float ? 'no-anime' : ''" :src="src" :alt="name">
        </div>
        <div class="card-item-base">
          <span class="card-info-count" v-show="nums > 1">X{{nums}}</span>
        </div>
        <div class="card-name">{{name}}</div>
        <div class="card-mask" v-if="status === 1 && animeOver">
          <i class="card-mask-icon"></i>
        </div>
      </div>
    </div>
    <div class="card-item card-backend"></div>
  </div>
</template>

<script>
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  props: {
    type: Number,
    src: String,
    name: String,
    nums: Number,
    float: Boolean,
    status: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      animeOver: false
    }
  },
  watch: {
    status (val) {
      if (val === 1) {
        // 翻转动画
        if (this.$bus.skipAnime) {
          this.$bus.rewardDialog.show = true
          this.$refs.card.style.transform = 'rotateY(0)'
          this.$bus.flipAnime = false
          this.animeOver = true
          return
        }
        this.$bus.flipAnime = true
        this.animeOver = false
        anime.rotateY(this.$refs.card, () => {
          this.$bus.rewardDialog.show = true
          this.$bus.flipAnime = false
          this.animeOver = true
        })
      } else {
        this.$refs.card.style.transform = 'rotateY(180deg)'
      }
    }
  },
  methods: {
    rotate () {
      if (this.status === 1) {
        this.animeOver = true
        anime.rotateY(this.$refs.card)
        return false
      }
    }
  },
  mounted () {
    this.rotate()
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  transform-style: preserve-3d;
  transform: rotateY(180deg);
}
.card-item {
  position: absolute;
  left: 0;
  top: 0;
  backface-visibility: hidden;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .5);
}
.card-backend {
  transform: rotateY(180deg);
}
.card.front-flip {
  transform: rotateY(0deg) !important;
}
.card-frontend.light {
  box-shadow: 0 0 8px 2px rgba(255, 220, 81, .8);
  animation: twinkle 1s ease-in-out both infinite alternate;
}
.card-frontend.light.no-anime {
  animation: none;
  box-shadow: none;
}
.card-inner {
  width: 100%;
  height: 100%;
  position: relative;
  @include flexcc;
  backface-visibility: hidden;
}
.card-info {
  @include px2res(width, 90);
  @include px2res(height, 90);
  // height: 20%;
  margin-bottom: 10%;
  transform: scale(1.4);
  position: relative;
  backface-visibility: hidden;
  text-align: center;
}
.card-info .card-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  // height: 100%;
  // width: auto;
  animation: float 2.5s ease-in-out infinite alternate both;
}
.card-info-count {
  position: absolute;
  color: #FFDD9C;
  @include px2res(bottom, 10);
  @include px2res(right, 20);
  @include px2res(height, 24);
  @include px2res(line-height, 24);
  @include px2res(font-size, 24);
  @include px2res(padding, 0, 15);
  font-style: italic;
  font-weight: 500;
  z-index: 2;
  backface-visibility: hidden;
}
.card-frontend.light .card-info-count {
  color: #110805;
}
.card-img.no-anime {
  animation: none !important;
}
.card-item-base {
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, 50%);
  @include px2res(width, 227);
  @include px2res(height, 134);
  backface-visibility: hidden;
}
.card-name {
  @include px2res(font-size, 28);
  line-height: 1;
  text-align: center;
  width: 90%;
  position: absolute;
  left: 50%;
  bottom: 24%;
  transform: translate(-50%, 50%);
  color: #FFE19D;
  font-style: italic;
  backface-visibility: hidden;
}
.card-frontend.light .card-name {
  color: #110805;
}
.card-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  @include flexcc;
  background-color: rgba(0, 0, 0, .5);
}
.card-mask-icon {
  @include px2res(width, 120);
  @include px2res(height, 120);
}
@keyframes twinkle {
  0% {
    box-shadow: 0 0 8px 2px rgba(255, 220, 81, .8);
  }
  100% {
    box-shadow: 0 0 8px 2px rgba(255, 220, 81, .2);
  }
}
@keyframes float {
  0% {
    transform: translate(0%, 0%);
  }
  50% {
    transform: translate(1%, -2%);
  }
  100% {
    transform: translate(-1%, 2%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/card.vue